import { Properties } from "../../core/internal/model/model"
import { Page } from "../../core/internal/page/Page"
import BrowserPropertyGenerator from "./BrowserPropertyGenerator"

export interface BrowserPropertyProvider {
  getBrowserProperties(): Properties
}

export default class DefaultBrowserPropertyProvider implements BrowserPropertyProvider {
  getBrowserProperties(page?: Page): Properties {
    return BrowserPropertyGenerator.generate(window, page ?? Page.createWithCurrentPage())
  }
}
